import styled from 'styled-components';
import { getTheme, ifStyle } from '~/modules';

const lgSpacing = getTheme('spacing.lg');
const mdSpacing = getTheme('spacing.md');
const backgroundZ1 = getTheme('background.z1');

const hasFooter = ifStyle('$hasFooter');

type WrapperProps = {
  $hasFooter: boolean;
};

export const Wrapper = styled.div<WrapperProps>`
  width: 100%;
  max-width: 1200px;
  padding-top: ${lgSpacing}px;
  display: flex;
  flex-direction: column;
  gap: ${mdSpacing}px;
  margin: 0 auto;
  flex: 1;
  position: relative;
  padding-bottom: ${hasFooter(
    'inherit',
    'max(24px, env(safe-area-inset-bottom))',
  )};
`;

export const WrapperContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${mdSpacing}px;
  flex: 1;
  width: 90%;
  margin-inline: auto;
`;

export const Footer = styled.div`
  border-top: 1px solid #1312641a;
  padding-top: ${lgSpacing}px;
  position: sticky;
  bottom: 0;
  background-color: ${backgroundZ1};
  padding-bottom: max(24px, env(safe-area-inset-bottom));
  padding-inline: 5%;
`;
